// extracted by mini-css-extract-plugin
module.exports = {"pages":"dragPage_pages__XokWn","addButton":"dragPage_addButton__HMTXV","addButtonInner":"dragPage_addButtonInner__mhg8N","addButtonWrap":"dragPage_addButtonWrap__RQDYM"};